import React, { useEffect } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import "./PageCategory.scss";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { isProfilePageState, isUserRightsState } from "recoil/contentsAtom";
import { useQuery } from "react-query";
import { getLoungeSectionList, ILoungeSectionList } from "api/commonApi";
import CategoryLoading from "components/common/loading/CategoryLoading";

function PageCategory() {
  const { t } = useTranslation();
  const isProfilePage = useRecoilValue(isProfilePageState);
  const location = useLocation();
  const { service_code, title, profilekey } = useParams();

  const { isLoading, data } = useQuery<ILoungeSectionList>(
    ["list", service_code],
    () => getLoungeSectionList(service_code || ""),
    {
      enabled: !(location.pathname.split("/")[1] === "profile")
    }
  );
  const setIsUserRights = useSetRecoilState(isUserRightsState);

  const allColor = title === undefined || title === "all" ? "on" : "";
  const postColor = title === undefined || title === "post" ? "on" : "";

  useEffect(() => {
    if (data?.result === -99) {
      (window as any).__sectionMinus99 = true;
      alert('不存在的Lounge');
      window.location.replace("https://xiyouxi.com/");
      return;
    }

    if (data?.result === 1) {
      setIsUserRights(data.data);
    }
  }, [data, setIsUserRights]);

  return !isLoading ? (
    <nav className="category clearfix">
      <ul className="clearfix">
        <li className={`lnb_cate ${!isProfilePage ? allColor : postColor}`}>
          <Link
            to={`${
              !isProfilePage
                ? `/page/${service_code}/all`
                : `/profile/${profilekey}/post`
            }`}
          >
            <i className="icon board " />
            {t(!isProfilePage ? "all" : "post")}
          </Link>
        </li>

        {data?.result === 1
          ? data?.data?.map((i) => (
              <li
                className={`lnb_cate ${i.title === title ? "on" : ""}`}
                key={i.idx}
              >
                <Link to={`/page/${service_code}/${i.title}`}>
                  {t(i.lang_code)}
                </Link>
              </li>
            ))
          : null}

        {isProfilePage && (
          <li className={`lnb_cate ${title === "like" ? "on" : ""}`}>
            <Link to={`/profile/${profilekey}/like`}>like</Link>
          </li>
        )}
      </ul>
    </nav>
  ) : (
    <CategoryLoading />
  );
}
const PageCategoryMemo = React.memo(PageCategory);
export default withTranslation()(PageCategoryMemo);
